import storiesDetail from './stories-detail';
import vars from '../helpers';
import gallery from '../components/gallery';

let $openBtn = null;
let $closeBtn = null;
let $menu = null;

function open() {
	storiesDetail.closeStoriesDetail();
	gallery.close();
	vars.$html.addClass('is-lock-scroll is-menu-opened');
	$menu.addClass('is-show');

	setTimeout(() => {
		$menu.addClass('is-open');
	}, 200);
}

function close() {
	vars.$html.removeClass('is-lock-scroll is-menu-opened');
	$menu.removeClass('is-open');

	setTimeout(() => {
		$menu.removeClass('is-show');
	}, 500);
}

function init(container) {
	$openBtn = $(container).find('.js-open-menu');
	$closeBtn = $(container).find('.js-close-menu');
	$menu = $(container).find('.menu');

	$openBtn.on('click', open);
	$closeBtn.on('click', close);
}

function destroy() {
	storiesDetail.closeStoriesDetail();
	$openBtn.off('click', open);
	$closeBtn.off('click', close);

	$openBtn = null;
	$closeBtn = null;
	$menu = null;
}

export default {
	init,
	destroy
}
